/**
 * This is a singleton class that stores the auth config.
 * @example
 * const authConfig = AuthConfig.getInstance();
 * const auth0Domain = authConfig.AUTH0_DOMAIN;
 * const auth0ClientId = authConfig.AUTH0_CLIENT_ID;
 * const auth0RedirectUri = authConfig.AUTH0_REDIRECT_URI;
 * const auth0Audience = authConfig.AUTH0_AUDIENCE;
 */
export class AuthConfig {
  private static _instance: AuthConfig;

  // Configuration properties
  public AUTH0_DOMAIN: string;
  public AUTH0_CLIENT_ID: string;
  public AUTH0_REDIRECT_URI: string;
  public AUTH0_AUDIENCE: string;

  // Private constructor to enforce singleton pattern
  private constructor() {
    this.AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
    this.AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
    this.AUTH0_REDIRECT_URI = import.meta.env.VITE_AUTH0_REDIRECT_URI;
    this.AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;
  }

  // Public method to get the singleton instance
  public static getInstance(): AuthConfig {
    if (!AuthConfig._instance) {
      AuthConfig._instance = new AuthConfig();
    }
    return AuthConfig._instance;
  }
}
